var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"modal-header\"> <h3 class=\"modal-title\" ng-i18next>kv_booking_process.prebook_error_modal_title</h3> </div> <div class=\"modal-body\"> <winres-fault error=\"error\"></winres-fault> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$dismiss()\">OK</button> </div> </web-component>";
var id1="prebookErrorModal.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresKvBookingProcess/prebookErrorModal.html
// module id = 520
// module chunks = 2